/**
 * When the PDF tool warns before working on a large set of files. From the measurements in #378
 * (Chromium, 4× slowed CPU): merging a 300-page, 37 MB scan took 1.3 s and about 300 MB; a
 * 1000-page, 123 MB merge needed about 1.2 GB, near where iOS Safari closes a tab. Phone figures
 * from the phone bench (#387 PR-3) will replace these.
 */
export const WARN_TOTAL_BYTES = 150 * 1024 * 1024;
export const WARN_TOTAL_PAGES = 500;

export type SizeAssessment = 'ok' | 'large';

export function assessSize(totalBytes: number, totalPages: number): SizeAssessment {
  return totalBytes > WARN_TOTAL_BYTES || totalPages > WARN_TOTAL_PAGES ? 'large' : 'ok';
}
